import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './conveyors.html'

/**
 * Administer Barcode Readers route
 *
 * @namespace routes.AdminConveyors
 * @type {TmrRoute}
 */
const route = {
  name: 'devices.conveyors.list',
  label: 'DEVICES.CONVEYORS.TITLE',
  url: '/conveyors',
  component: 'tmrAdminConveyors',
  weight: 8,
  resourceType: 'Conveyor',
  resourceList: {
    searchParameters: ['code', 'description', 'place.id', 'user.id'],
  },
  resolve: {
    conveyorTypes: /*@ngInject*/ tmrConveyorTypes => tmrConveyorTypes,
    conveyorModeTypes: /*@ngInject*/ tmrConveyorModeTypes =>
      tmrConveyorModeTypes,
  },
}

/**
 * Delete Conveyor route override
 *
 * @namespace routes.DevicesConveyorDelete
 * @type {TmrRoute}
 */
let deleteRoute = {
  name: 'devices.conveyors.view.delete',
  resolve: {
    canDelete: /*@ngInject*/ (ConveyorPackageEvent, resource) =>
      resource.$canDelete().then(result => {
        // Checks if conveyor is referenced by package events. Can't be in $canDelete because it would
        // form a circular dependency.
        if (result === true)
          return ConveyorPackageEvent.count({
            'conveyor.id': resource.id,
          }).then(count =>
            Promise.resolve(
              count === 0 ? true : 'RESOURCEDELETE.CANTDELETE.CONVEYOREVENT'
            )
          )
        return result
      }),
  },
}

export const routes = [route, deleteRoute]

/**
 * Component for {@link routes.tmrAdminConveyors Administer Conveyors route}
 *
 * @type {ngComponent}
 */
export const tmrAdminConveyors = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings({
    conveyorTypes: '<',
    conveyorModeTypes: '<',
  }),
}
